export const UNASSIGNED_ID = -1;

export const isUnassigned = (id: number | undefined): boolean =>
    id === undefined || id === UNASSIGNED_ID;
